// extracted by mini-css-extract-plugin
export default {"map":"YandexMap_map__8jolz"};